import React, { useRef, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Queryform from './Queryform';
import Footer from '../home/Footer';
import tarotcard from "../assets/tarotImages/lovetarot.jpg"; // Ensure this path is correct
import { useNavigate } from 'react-router';
import dailyHoroscope from "../assets/rootimg/kundlicomp.png";
import rings from "../assets/rootimg/two-rings.png";
import compatibility from "../assets/rootimg/compatibility.png";
import { Link } from 'react-router-dom';
import crypto from 'crypto-js'; // Import crypto-js for MD5 hashing
import Navbar from '../home/Navbar';
import loader from "../assets/rootimg/tarot-loadergif.gif";

const LoveTarot = () => {
  const [isActive, setIsActive] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const smallScrollRef = useRef(null);
  const mediumScrollRef = useRef(null);

  // Scroll functions for small devices
  const scrollSmallLeft = () => {
    if (smallScrollRef.current) {
      smallScrollRef.current.scrollBy({ left: -150, behavior: 'smooth' });
    }
  };

  const scrollSmallRight = () => {
    if (smallScrollRef.current) {
      smallScrollRef.current.scrollBy({ left: 150, behavior: 'smooth' });
    }
  };

  // Scroll functions for medium devices
  const scrollMediumLeft = () => {
    if (mediumScrollRef.current) {
      mediumScrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollMediumRight = () => {
    if (mediumScrollRef.current) {
      mediumScrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  const navigate = useNavigate();
  const kundliClick = (e) => {
    e.preventDefault();
    navigate('/kundlimatching');
  }
  const horoscopeClick = (e) => {
    e.preventDefault();
    navigate('/horoscope');
  }
  const compatibilityClick = (e) => {
    e.preventDefault();
    navigate('/compatibility');
  }

  // Helper function to create unique hash-based IDs
  const generateUniqueId = (cardName) => {
    const hash = crypto.MD5(cardName).toString(crypto.enc.Base64); // Hash the card name and convert to Base64
    return hash.substring(0, 25); // Take the first 5 characters for the unique ID
  };

  let lastPickedCard = null;

  const pickCard = () => {
    // Show loader
    setIsLoading(true);

    // Define an array of possible routes using hashed unique 5-digit IDs
    const routes = [

      `/love/tarot/${generateUniqueId('World')}`,
      `/love/tarot/${generateUniqueId('Chariot')}`,
      `/love/tarot/${generateUniqueId('Emperor')}`,
      `/love/tarot/${generateUniqueId('Hangedman')}`,
      `/love/tarot/${generateUniqueId('Death')}`,
      `/love/tarot/${generateUniqueId('Justice')}`,
      `/love/tarot/${generateUniqueId('Hermit')}`,
      `/love/tarot/${generateUniqueId('Lovers')}`,
      `/love/tarot/${generateUniqueId('Hierophant')}`,
      `/love/tarot/${generateUniqueId('Moon')}`,
      `/love/tarot/${generateUniqueId('Priestess')}`,
      `/love/tarot/${generateUniqueId('Sun')}`,
      `/love/tarot/${generateUniqueId('Temperance')}`,
      `/love/tarot/${generateUniqueId('Tower')}`,
      `/love/tarot/${generateUniqueId('Wheelfortune')}`,

    ];

    // If no card has been picked yet or lastPickedCard is null, pick a new card
    if (!lastPickedCard) {
      lastPickedCard = routes[Math.floor(Math.random() * routes.length)];
    }

    // Otherwise, use the last picked card
    const randomRoute = lastPickedCard;

    // Wait for 3 seconds before navigating
    setTimeout(() => {
      setIsLoading(false);
      // Navigate to the route (same card)
      navigate(randomRoute);
    }, 3000);
  }

  return (
    <>
      <section className="bg-gradient-to-r from-gray-100 to-gray-300/80 text-gray-900 min-h-screen">
        <Navbar />

        <div className="mt-0">
          <div className="flex-grow flex flex-col items-center px-4 sm:px-6 lg:px-8">
            <h1 className="text-center text-3xl font-bold font-serif text-secondary mt-10">
              LOVE TAROT
            </h1>
            <h2 className="text-lg max-w-4xl mt-2 text-center font-semibold text-secondary">
              Know what's in store for you romantically each day with your Love Tarot reading. Hot date? Drama? Lonely night? Find out what to expect now...
            </h2>

            {/* Loader overlay */}
            {isLoading && (
              <div className="fixed inset-0 bg-white bg-opacity-60 flex items-center justify-center z-50">
                <div className="text-center">
                  <img src={loader} alt="Loading..." className="w-full h-full mx-auto bg-transparent" />
                  <p className="text-secondary font-serif mt-4 text-xl">Reading your cards...</p>
                </div>
              </div>
            )}

            <h3 className="text-md mt-2">Pick A Card</h3>
            <p className="text-md">
              What does the future have in store for you? Now is the time to discover the day’s possibilities!
            </p>

            {/* Large Devices - Fan Spread */}
            <div className="relative w-full justify-center items-center -mt-10 h-[550px] hidden lg:flex">
              {[...Array(13)].map((_, index) => {
                const rotationAngle = -18 + index * 3;
                const zIndex = index;
                const marginTop = index <= 6 ? 20 * (6 - index) : 20 * (index - 6);
                const marginLeft = index <= 6 ? -130 * (6 - index) : 130 * (index - 6);
                const marginBottom = index <= 6 ? -10 * (6 - index) : -10 * (index - 6);

                return (
                  <div
                    key={index}
                    className="absolute"
                    onMouseEnter={() => setIsActive(index)}
                    onMouseLeave={() => setIsActive(null)}
                    onClick={pickCard}
                    style={{
                      transform: `rotate(${rotationAngle}deg)`,
                      zIndex: zIndex,
                      marginTop: `${marginTop}px`,
                      marginLeft: `${marginLeft}px`,
                      marginBottom: `${marginBottom}px`,
                    }}
                  >
                    <img
                      src={tarotcard}
                      alt="tarot"
                      className={`w-auto h-80 object-cover rounded-md transition-all duration-300 ease-in-out transform 
                        hover:scale-[1.09] hover:ring-4 cursor-pointer hover:ring-black/70 hover:translate-y-[-20px] focus:outline-none`}
                    />
                  </div>
                );
              })}
            </div>

            {/* Small Devices - Horizontal Scroll Slider */}
            <div className="relative flex sm:hidden w-full items-center mt-4">
              <button
                className="absolute left-0 bg-secondary text-white p-2 rounded-full z-10"
                onClick={scrollSmallLeft}
              >
                <FaChevronLeft />
              </button>

              <div
                className="flex overflow-x-scroll scrollbar-hide space-x-2 px-8"
                ref={smallScrollRef}
                style={{ scrollBehavior: 'smooth' }}
              >
                {[...Array(15)].map((_, index) => (
                  <img
                    key={index}
                    src={tarotcard}
                    alt="tarot"
                    className="w-32 h-48 object-cover rounded-md transition-transform duration-300 ease-in-out transform hover:-translate-y-2 cursor-pointer flex-shrink-0"
                    onClick={pickCard}
                  />
                ))}
              </div>

              <button
                className="absolute right-0 bg-secondary text-white p-2 rounded-full z-10"
                onClick={scrollSmallRight}
              >
                <FaChevronRight />
              </button>
            </div>

            {/* Medium Devices - Horizontal Scroll Slider */}
            <div className="relative hidden sm:flex lg:hidden w-full items-center mt-4">
              <button
                className="absolute left-0 bg-secondary text-white p-2 rounded-full z-10"
                onClick={scrollMediumLeft}
              >
                <FaChevronLeft />
              </button>

              <div
                className="flex overflow-x-scroll scrollbar-hide space-x-2 px-8"
                ref={mediumScrollRef}
                style={{ scrollBehavior: 'smooth' }}
              >
                {[...Array(15)].map((_, index) => (
                  <img
                    key={index}
                    src={tarotcard}
                    alt="tarot"
                    className="w-36 h-56 object-cover rounded-md transition-transform duration-300 ease-in-out transform hover:-translate-y-2 cursor-pointer flex-shrink-0"
                    onClick={pickCard}
                  />
                ))}
              </div>

              <button
                className="absolute right-0 bg-secondary text-white p-2 rounded-full z-10"
                onClick={scrollMediumRight}
              >
                <FaChevronRight />
              </button>
            </div>
            <div className='text-center'>
              <h2 className="text-2xl font-semibold text-secondary mt-10">
                About This Reading
              </h2>
              <p className="text-lg  max-w-4xl text-gray-700 mt-5">
                What exactly is Tarot, and how does it work? Tarot is a deck of cards designed to help clarify our thoughts and guide us in making informed decisions. You can pose almost any question to the Tarot, and it will provide insights drawn from both your current circumstances and past experiences. If you're looking for advice on love, Tarot can delve into your current relationship or even reflect on a previous one, perfect for those moments when you're reminiscing about an ex.
              </p>
              <p className="text-lg max-w-4xl text-gray-700 mt-5">
                You might be wondering: how can a simple deck of cards assist in making significant life decisions? The answer lies in energy. According to the Law of Attraction, what you project into the world is what you draw back to yourself. When you seek guidance from Tarot, the cards that come up are directly responding to your inquiry. Keep in mind that the cards that appear are meant to do so.
              </p>
            </div>
            <div className='flex flex-col w-4/5'>
              <hr className="border-secondary border-[1.5px] w-full mt-10" />
              <p className="text-center mt-5">
                Discover your highest truth with the guidance of a gifted psychic reader.
              </p>
              <Link className="text-center">Click here to claim your free reading!</Link>
              <hr className="border-secondary border-[1.5px]  w-full mt-5 mb-6" />
            </div>
            <div className=" flex flex-col ml-4 sm:ml-8 md:ml-16 lg:ml-16 mr-4 sm:mr-8 md:mr-16 lg:mr-16 justify-center items-center">
              <h1 className="text-center text-lg sm:text-xl md:text-2xl text-secondary mt-8 font-bold">
                Recommended Reports For You
              </h1>

              {/* Parent Card div */}
              <div className="flex flex-wrap gap-5 justify-center mt-5">
                {/* Card 1 */}
                <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                  <div className="flex flex-col items-center">
                    <img
                      src={rings}
                      alt="kundli.png"
                      className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                    />
                    <div className="text-center">
                      <h3 className="text-lg sm:text-xl font-bold mb-2 text-center text-secondary">Kundli Matching</h3>
                      <p className="text-justify text-xs sm:text-sm md:text-base m-3 mb-4">
                        Kundli Matching helps you find a match for your astrological traits and preferences. By comparing your birth
                        chart with others in the database, you can find a person who shares your similarities, characteristics, and
                        compatible energies.
                      </p>
                      <button
                        onClick={kundliClick}
                        className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                      >
                        Match Kundli
                      </button>
                    </div>
                  </div>
                </div>

                {/* Card 2 */}
                <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                  <div className="flex flex-col items-center">
                    <img
                      src={dailyHoroscope}
                      alt="daily-horoscope.png"
                      className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                    />
                    <div className="text-center">
                      <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Daily Horoscope</h3>
                      <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-6">
                        Get your personalized daily horoscope and insights for the day ahead. Stay prepared and make the
                        most of your day with astrological guidance to navigate challenges, seize opportunities, and align with cosmic energy.
                      </p>
                      <button
                        onClick={horoscopeClick}
                        className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                      >
                        View Horoscope
                      </button>
                    </div>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="bg-white w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto p-4 rounded-lg">
                  <div className="flex flex-col items-center">
                    <img
                      src={compatibility}
                      alt="daily-horoscope.png"
                      className="w-20 sm:w-24 md:w-28 lg:w-32 max-h-fit m-4 border rounded-xl border-white bg-white"
                    />
                    <div className="text-center">
                      <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Compatibility</h3>
                      <p className="text-xs text-justify sm:text-sm md:text-base m-3 mb-4">
                        Compatibility helps you understand how well your astrological traits
                        align with those of another person. By comparing your birth chart with
                        others in the database, you can find a person who shares your
                        similarities and characteristics.
                      </p>
                      <button
                        onClick={compatibilityClick}
                        className="bg-secondary w-fit h-auto p-2 sm:p-3 rounded-md hover:bg-success text-white"
                      >
                        Check Compatibility
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Queryform />
        </div>
        <Footer />
      </section>
    </>
  );
};

export default LoveTarot;
